import moment from 'moment';
import { CalendarTypeEnum } from '@/enums/CalendarTypeEnum';
import { EventsTypes } from '@/enums/EventsTypes';
import { EditRecurringEventTypes } from '@/enums/EditRecurringEventTypes';
import { EventsTypesMinor } from "@/enums/EventsTypesMinor";
import { toTranslationKey } from "@/utils/stringFormat";
import { EventLocations } from '@/enums/EventLocations';
import { fixString } from '@/utils/fixString';
import { CalendarScreenTypeEnum } from '@/enums/CalendarScreenTypeEnum';
import {EventLocationsMixin} from "@/mixins/EventLocations";
import {CalendarTimeFormatMixin} from "@/mixins/CalendarTimeFormat";

export default {
  name: "Calendar",
  mixins: [EventLocationsMixin, CalendarTimeFormatMixin],
  components: {
    Loader: () => import('@/components/loader/Loader.vue'),
    ScheduleView: () => import('@/views/calender/schedule-view/ScheduleView.vue'),
    EventPreviewCard: () => import('@/views/calender/event-preview-card/EventPreviewCard.vue'),
    PublishEventsByPeriodDialog: () => import('@/views/calender/view-calendar-item/PublishEventsByPeriodDialog.vue'),
    PrintableCalendarHeader: () => import('@/views/calender/printable-calendar-components/printable-calendar-header/PrintableCalendarHeader.vue'),
    PrintableCalendarMain: () => import('@/views/calender/printable-calendar-components/printable-calendar-main/PrintableCalendarMain.vue')
  },
  data() {
    return {
      typeToLabel: CalendarTypeEnum,
      absolute: true,
      overlay: false,
      dialog: false,
      valid: true,
      group: [],
      today: null,
      focus: '',
      type: 'week',
      start: null,
      end: null,
      dateDefault: '',
      isOpenEditRecurringEventOptionsDialog: false,
      editRecurringEventType: EditRecurringEventTypes.SelectedEvent,
      calendarScreenTypeEnum: CalendarScreenTypeEnum,
      selectedEventId: null,
      selectedWing: null,
      selectedCategoryColor: '',
      selectedCategoryId: '',
      selectedCategoryName: '',
      lifestyleProgramsSearchValue: '',
      locationSearchValue: '',
      residentSearchValue: '',
      wingSearchValue: '',
      lifestyleProgramsEnabled: true,
      locationEnabled: false,
      wingEnabled: false,
      residentEnabled: false,
      filters: [
        EventsTypes.ConciergeRequest,
        EventsTypes.LifestylePrograms,
        EventsTypes.PremiumServices,
        EventsTypes.Meal
      ],
      isToggleCalendar: false,
      calendarScreenshot: null,
      logoScreenshot: null,
      currentData: moment(new Date()).format("YYYY-MM-DD"),
      now: moment(new Date()).format("YYYY-MM-DD"),
      locations: [],
      isOpenCalendarCard: false,
      isOpenPublishDraftsDialog: false,
      currentCalendarScreenType: this.$store.state.calenderModule.mainCalendarFilters.screenType,
      startSchedule: new Date(),
    }
  },
  methods: {
    onScheduleCalendarScreenTypeChange(e){
      if(e === CalendarScreenTypeEnum.Schedule){
        this.$store.dispatch("setMainCalendarFilters", {screenType: CalendarScreenTypeEnum.Schedule});
      }
      else{
        this.$store.dispatch("setMainCalendarFilters", {screenType: CalendarScreenTypeEnum.Calendar});
      }

      this.currentCalendarScreenType = this.$store.state.calenderModule.mainCalendarFilters?.screenType || CalendarScreenTypeEnum.Calendar
    },

    onWingChange(wing){
      this.selectedWing = wing.name;
      this.$store.dispatch("setMainCalendarFilters", { wingName: this.selectedWing, wingId: wing.id});
    },
    
    onCategoryChange(category){
      if(category){
        this.selectedCategoryColor = category.color
        this.selectedCategoryName = category.name
        this.selectedCategoryId = category.id
        this.$store.dispatch("setMainCalendarFilters", { categoryColor: this.selectedCategoryColor });
      }
      else{
        this.selectedCategoryColor = null
        this.selectedCategoryName = null
        this.selectedCategoryId = null
        this.$store.dispatch("setMainCalendarFilters", { categoryColor: null });
      }
    },

    convertToTranslationKey(text: string) {
      return toTranslationKey(text)
    },
    checkCalendarFilterParams() {
      this.filters = this.$store.state.calenderModule.mainCalendarFilters.filters || this.filters;
      this.lifestyleProgramsEnabled = this.$store.state.calenderModule.mainCalendarFilters.lifestyleProgramsEnabled || this.lifestyleProgramsEnabled;
      this.lifestyleProgramsSearchValue = this.$store.state.calenderModule.mainCalendarFilters.lifestyleProgramsSearchValue || this.lifestyleProgramsSearchValue;
      this.locationEnabled = this.$store.state.calenderModule.mainCalendarFilters.locationEnabled || this.locationEnabled;
      this.locationSearchValue = this.$store.state.calenderModule.mainCalendarFilters.locationSearchValue || this.locationSearchValue;
      this.residentEnabled = this.$store.state.calenderModule.mainCalendarFilters.residentEnabled || this.residentEnabled;
      this.residentSearchValue = this.$store.state.calenderModule.mainCalendarFilters.residentSearchValue || this.residentSearchValue;
      this.type = this.$store.state.calenderModule.mainCalendarFilters.type || this.type;
      this.selectedWing = this.$store.state.calenderModule.mainCalendarFilters.wingName || this.selectedWing;
      this.selectedWingsIds = this.$store.state.calenderModule.mainCalendarFilters.wingsIds || this.selectedWingsIds;
      this.selectedCategoryColor = this.$store.state.calenderModule.mainCalendarFilters.categoryColor || this.selectedCategoryColor;
    },

    moveToCurrentWeek() {
      if (this.$route.params?.currentWeek) {
        this.focus = this.$route.params.currentWeek;
      }
    },

    fixString(str, cut) {
      return fixString(str, 15, cut)
    },

    viewDay({ date }): void {
      let route = true;
      const currentDate = moment(date).format("YYYY-MM-DD");
      this.events.forEach(event => {
        const eventStart = moment(event.start).format("YYYY-MM-DD");
        const eventEnd = moment(event.end).format("YYYY-MM-DD");
        if (currentDate >= eventStart && currentDate <= eventEnd) {
          this.focus = date;
          this.type = 'day';
          this.dateDefault = date;
          route = false;
        }
      });
      if (route) {
        this.$router.push({
          name: 'NewCalendarItem',
          params: { dateSelected: date },
        });
      }
    },

    getEventColor(event): string {
      return "#ffffff";
    },

    async setToday() {
      if(this.currentCalendarScreenType === this.calendarScreenTypeEnum.Calendar) {
        this.focus = this.today;
      } else {
        this.startSchedule = new Date();

        await this.onRangeChange({
          start: { date: moment(new Date()).format("YYYY-MM-DD") },
          end: { date: moment(new Date().setDate(new Date().getDate() + 7)).format("YYYY-MM-DD") }
        });
      }
    },

    async prev() {
      await this.navigateCalendar('prev');
    },

    async next() {
      await this.navigateCalendar('next');
    },

    async updateSchedule(days: number) {
      await this.onRangeChange({
        start: { date: moment(this.startSchedule).format("YYYY-MM-DD") },
        end: { date: moment(this.startSchedule.setDate(this.startSchedule.getDate() + days)).format("YYYY-MM-DD") }
      });
    },

    async navigateCalendar(direction: 'prev' | 'next') {
      if (this.currentCalendarScreenType === this.calendarScreenTypeEnum.Calendar) {
        this.$refs.calendar[direction]();
      } else {
        let days = 0;
        if (this.type === CalendarTypeEnum.week) {
          days = 7;
        } else if (this.type === CalendarTypeEnum['4day']) {
          days = 4;
        } else if (this.type === CalendarTypeEnum.day) {
          days = 1;
        }

        await this.updateSchedule(direction === 'prev' ? -days : +days);
      }
    },

    showEvent({ nativeEvent, event }): void {
      this.isOpenCalendarCard = true;
      this.$refs.eventPreviewCard.open(nativeEvent.target, event, CalendarScreenTypeEnum.Calendar);
    },

    intervalFormatter(locale, getOptions) {
      const format = this.facility.timeFormat.split(' ')[1] || ''
      let timeFormatted = moment(locale.time, ["HH:mm"]).format(`${format == 'A' ? 'h' : 'H'}${format ? ' ' + format : ''}`)
      timeFormatted = timeFormatted === '0' ? '24' : timeFormatted

      return timeFormatted;
    },

    nth(d) {
      return d > 3 && d < 21
        ? 'th'
        : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
    },

    createEvent(): void {
      this.$router.push({
        name: 'NewCalendarItem',
        params: { dateSelected: this.dateSelected },
      });
    },

    async onRangeChange(range) {
      const start = moment(range.start.date).add(-1, 'months').toDate()
      const end = moment(range.end.date).add(1, 'months').toDate()

      setTimeout(() => {
        if(this.$refs.calendar){
          this.$refs.calendar.scrollToTime('07:00')
        }
      }, 100)

      await this.$store.dispatch('getCalenderEvents', { start: start, end: end });
    },

    createEventByTime(data): void {
      if (this.isOpenCalendarCard) return;

      const date = data.date;
      const start = moment(`${data.hour}`, 'h:mma').format(this.facility.timeFormat);
      const now = moment(new Date()).format("HH:mm");
      const startModify = moment(`${data.hour}`, 'h:mma').format("HH:mm");

      let eventDate = '';
      let eventStart = '';

      if (this.currentData < date) {
        eventDate = date;
        eventStart = start;
      } else if (this.currentData === date && now < startModify) {
        eventDate = this.currentData;
        eventStart = start;
      } else {
        eventDate = this.currentData;
        eventStart = moment(new Date()).format(this.facility.timeFormat);
      }

      this.$router.push({
        name: 'NewCalendarItem',
        params: {
          dateSelected: eventDate,
          timeStart: eventStart,
        },
      });
    },

    updateRange({ start, end }): void {
      this.start = start;
      this.end = end;
    },

    isVideoCallWasEnabled() {
      if (this.$route.params.isVideoCallEnabled) {
        this.filters.push(EventsTypes.ScheduledCall, EventsTypes.RealtimeCall)
      }
    },
    checkTime(startTime, endTime) {
      const start: any = Number(moment(startTime).format("HH")) * 60 + Number(moment(startTime).format("mm"));
      const end: any = Number(moment(endTime).format("HH")) * 60 + Number(moment(endTime).format("mm"));
      return (end - start) >= 60;
    },

    getEventsByCalendarType(applyMainFilters) {
      let events = applyMainFilters? [...this.events]:[...this.allEventsByDateRange]
      let fromDate = moment(this.startSchedule).add(-1, "months").startOf("day").toDate();
      let toDate = moment(this.startSchedule).add(1, "month").endOf("day").toDate();

      if (this.type === CalendarTypeEnum.day) {
        fromDate = moment(this.startSchedule).startOf("day").toDate();
        toDate = moment(this.startSchedule).endOf("day").toDate();
      }
      else if (this.type === CalendarTypeEnum['4day']) {
        fromDate = moment(this.startSchedule).startOf("day").toDate();
        toDate = moment(this.startSchedule).add(3, "day").endOf("day").toDate();
      }
      else if (this.type === CalendarTypeEnum.week) {
        fromDate = moment(this.startSchedule).startOf("week").toDate();
        toDate = moment(this.startSchedule).endOf("week").toDate();
      }
      else if (this.type === CalendarTypeEnum.month) {
        fromDate = moment(this.startSchedule).add(-1, "months").startOf("day").toDate();
        toDate = moment(this.startSchedule).add(1, "month").endOf("day").toDate();
      }

      events = events.filter(x => x.startDate >= fromDate && x.startDate <= toDate)

      return events
    },

    addRealtimeCalls() {
      if (!this.filters.includes(this.eventTypes.RealtimeCall)) {
        this.filters.push(this.eventTypes.RealtimeCall)
      } else {
        this.filters = this.filters.filter(x => x !== this.eventTypes.RealtimeCall)
      }
    },

    async openPrintableCalendar() {
      this.$router.push({ name: 'PrintableCalendar' });
    },

    openPublishDraftsDialog(){
      this.isOpenPublishDraftsDialog = true
    },

    closeCalendarCard() {
      this.isOpenCalendarCard = false
    },

    formatDate(a, withTime): string {
      if (!a) return ''

      return withTime
        ? `${a.getFullYear()}-${a.getMonth() +
        1}-${a.getDate()} ${a.getHours()}:${(a.getMinutes() < 10 ? '0' : '') + a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },

    getColor(type, allDay, isPublished): string {

      let color = '#ffa500'

      if (type == EventsTypes.LifestylePrograms) color = '#0D47A1'
      else if (type == EventsTypes.PremiumServices) color = '#4caf50'
      else if (type == EventsTypes.Notice) color = '#ff0000'
      else if (type == EventsTypes.FamilyVisit) color = '#4b0082'
      else if (type == EventsTypes.Medical) color = '#ffc0cb'
      else if (type == EventsTypes.Concierge) color = '#ffa500'
      else if (type == EventsTypes.RealtimeCall) color = '#03A9F4'
      else if (type == EventsTypes.ScheduledCall) color = '#03A9F4'
      else if (type == EventsTypes.Meal) color = '#009688'


      //Make color more lighter for Draft and AllDay events

      if (!isPublished) {
        // Convert color to HSL
        const hslColor = this.hexToHSL(color);

        // Increase lightness value (adjust the value as desired)
        hslColor.l += 0.3;

        // Convert back to hexadecimal
        color = this.hslToHex(hslColor);

        return color
      }

      if (allDay) {
        // Convert color to HSL
        const hslColor = this.hexToHSL(color);

        // Increase lightness value (adjust the value as desired)
        hslColor.l += 0.2;

        // Convert back to hexadecimal
        color = this.hslToHex(hslColor);

        return color
      }

      return color
    },

    // Helper function to convert hexadecimal color to HSL
    hexToHSL(hex) {
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      let r = parseInt(result[1], 16);
      let g = parseInt(result[2], 16);
      let b = parseInt(result[3], 16);

      let h, s;
      r /= 255;
      g /= 255;
      b /= 255;
      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);

      const l = (max + min) / 2;

      if (max === min) {
        h = s = 0; // achromatic
      } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        h /= 6;
      }

      return { h, s, l };
    },

    //Helper function converts HSL color values to a hexadecimal color representation.
    hslToHex(hsl) {
      const { h, s, l } = hsl;
      let r, g, b;

      if (s === 0) {
        r = g = b = l; // achromatic
      } else {
        const hue2rgb = (p, q, t) => {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1 / 6) return p + (q - p) * 6 * t;
          if (t < 1 / 2) return q;
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
          return p;
        };

        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;

        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }

      const toHex = (c) => {
        const hex = Math.round(c * 255).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };

      const hex = `#${toHex(r)}${toHex(g)}${toHex(b)}`;
      return hex;
    },
    focusOnDay(date) {
      this.focus = date;
      this.type = this.typeToLabel.day;
    },
    getEventIcon(type) {

      switch (type) {
        case this.eventTypes.LifestylePrograms:
          return "mdi-basketball";
        case this.eventTypes.PremiumServices:
          return "mdi-face-agent";
        case this.eventTypes.Meal:
          return "mdi-silverware-fork-knife";
        case this.eventTypes.Notice:
          return "mdi-bulletin-board";
        case this.eventTypes.ScheduledCall:
          return "mdi-phone";
        case this.eventTypes.RealtimeCall:
          return "mdi-phone";
      }
    },
    getBorderColor(wingsIds) {
      if(wingsIds && wingsIds.length && wingsIds.length === 1) {
        return this.wings.find(x => x.id === wingsIds[0])?.color ?? "";
      }

      return "";
    },
  },
  async created() {
    this.moveToCurrentWeek();
    this.isVideoCallWasEnabled();
    await this.$store.dispatch("getFacility")
    await this.$store.dispatch("getEventLocations");
    this.checkCalendarFilterParams();
  },
  mounted() {
    setTimeout(() => {
      if(this.$refs.calendar){
        this.$refs.calendar.scrollToTime('07:00')
      }
    }, 100)
  },
  computed: {
    premiumFeatures(){
      return this.$store.getters.premiumFeatures
    },
    isScheduleCalendarScreenType() {
      return this.currentCalendarScreenType === CalendarScreenTypeEnum.Schedule;
    },
    eventTypes() {
      return EventsTypes;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    dateSelected(): any {
      return this.dateDefault
        ? this.dateDefault
        : moment(new Date()).format("YYYY-MM-DD");
    },
    title(): string {
      const { start, end } = this;
      if (!start || !end) {
        return '';
      }
      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? '' : endMonth;
      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? '' : endYear;
      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);
      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`;
        case 'week':
        case '4day':
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return '';
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC',
        month: 'long',
      });
    },
    wings() {
      return this.$store.state.eventLocationModule.eventLocations.filter(x => x.type === EventLocations.Wing);
    },
    categories() {
      return this.$store.state.socialClubModule.lifestyleProgramCategories
    },
    filteredCategories() {
      // Get all categories that are actually used in the current calendar events
      const allCategories = this.$store.state.socialClubModule.lifestyleProgramCategories;
      const usedCategoryIds = new Set();
      
      // Collect all unique category IDs from events (before dimension filter is applied)
      // Use allEventsByDateRange instead of events to avoid circular filtering
      this.allEventsByDateRange.forEach(event => {
        if (event.lifestyleProgramCategoryId) {
          usedCategoryIds.add(event.lifestyleProgramCategoryId);
        }
      });
      
      // Filter categories to only show those that have events
      return allCategories.filter(category => usedCategoryIds.has(category.id));
    },
    allEventsByDateRange() {
      const calenderEvents = this.$store.state.calenderModule.calenderEvents;

      const events = calenderEvents.map(dbEvt => ({
        name: (dbEvt.type === EventsTypesMinor.RealtimeCall || dbEvt.type === EventsTypesMinor.ScheduledCall) ? `${dbEvt.inviterName} - ${dbEvt.name}` : dbEvt.name,
        id: dbEvt.id,
        office365EventId: dbEvt?.office365EventId || null,
        imageUrl: dbEvt.imageUrl,
        attendees: dbEvt.attendees,
        description: dbEvt.description,
        isVirtualEvent: dbEvt.isVirtualEvent,
        going: dbEvt.going,
        notgoing: dbEvt.notgoing,
        goingLen: dbEvt.going?.length,
        notgoingLen: dbEvt.notgoing?.length,
        invitees: dbEvt.invitees,
        attendeesLen: dbEvt.invitees?.length,
        attendeesNames: dbEvt.attendeesNames,
        isRecurring: dbEvt.isRecurring,
        start: dbEvt.allDay ? moment(dbEvt.start.seconds * 1000).format("YYYY-MM-DD") : this.formatDate(moment(dbEvt.start.seconds * 1000).toDate(), true),
        end: dbEvt.allDay ? null : this.formatDate(dbEvt.end ? moment(dbEvt.end.seconds * 1000).toDate() : null, true),
        startDate: moment(dbEvt.start.seconds * 1000).toDate(),
        endDate: dbEvt.end ? moment(dbEvt.end.seconds * 1000).toDate() : null,
        color: this.getColor(dbEvt.type, dbEvt.allDay, dbEvt.isPublished),
        type: dbEvt.type,
        allDay: dbEvt.allDay,
        location: dbEvt.location,
        createdByResidentId: dbEvt.createdByResidentId,
        createdByStaffId: dbEvt.createdByStaffId,
        createdByFamilyUserId: dbEvt.createdByFamilyUserId,
        lifestyleProgramCategoryId: dbEvt.lifestyleProgramCategoryId,
        lifestyleProgramCategoryName: dbEvt.lifestyleProgramCategoryName,
        lifestyleProgramCategoryColor: dbEvt.lifestyleProgramCategoryColor,
        lifestyleProgramsNames: dbEvt.lifestyleProgramsNames,
        parentEventId: dbEvt.parentEventId,
        isPublished: dbEvt.isPublished,
        scheduledPublishDateTime: dbEvt.scheduledPublishDateTime || null,
        wing: dbEvt?.wing ?? '',
        wingsIds: dbEvt?.wingsIds ?? [],
        serviceRequestsResidentsNames: dbEvt.serviceRequestsResidentsNames,
        borderColor: this.getBorderColor(dbEvt?.wingsIds),
        icon: this.getEventIcon(dbEvt.type)
      }));

      return events
    },
    calendarRef() {
      return this.$refs.calendar;
    },
    eventsByCalendarType() {
      return this.getEventsByCalendarType(true);
    },
    scheduleViewKey() {
      return `${this.type}|${this.selectedWingsIds.join(',')}|${this.selectedCategoryId}|${this.filters.join(',')}`;
    },
    events() {

      const lifestyleProgramsSearchValueLower = this.lifestyleProgramsSearchValue?.toLowerCase();
      const locationSearchValueLower = this.locationSearchValue?.toLowerCase();
      const wingSearchValueLower = this.wingSearchValue?.toLowerCase();
      const residentSearchValueLower = this.residentSearchValue?.toLowerCase();

      let events = this.allEventsByDateRange.filter(event => {
        if (
          event.type === EventsTypes.LifestylePrograms ||
          event.type === EventsTypes.PremiumServices ||
          event.type === EventsTypes.ConciergeRequest ||
          event.type === EventsTypes.ScheduledCall ||
          event.type === EventsTypes.RealtimeCall ||
          event.type === EventsTypes.Meal
        ) {

          return this.filters.includes(event.type);
        }

        return event
      })

      if(this.selectedWingsIds.length) {
        events = events.filter(x => x.isPublished && (x.wingsIds && x.wingsIds.length && x.wingsIds.some(id => this.selectedWingsIds.includes(id)) || x.wingsIds.includes("All") || !x.wingsIds || !x.wingsIds.length))
      }
      
      if (this.selectedCategoryId) {
        events = events.filter(x => x.lifestyleProgramCategoryColor?.length? x.lifestyleProgramCategoryColor === this.selectedCategoryColor
          : x.lifestyleProgramCategoryId === this.selectedCategoryId)
      }

      if (lifestyleProgramsSearchValueLower?.length) {
        events = events.filter(x => x.lifestyleProgramsNames && x.lifestyleProgramsNames.some(n => n.toLowerCase().includes(lifestyleProgramsSearchValueLower)));
      }

      if (locationSearchValueLower?.length) {
        events = events.filter(x => x.location.toLowerCase().includes(locationSearchValueLower));
      }

      if (wingSearchValueLower?.length) {
        events = events.filter(x => x.wing.toLowerCase().includes(wingSearchValueLower));
      }

      if (residentSearchValueLower?.length) {
        events = events.filter(x =>
          (x.attendeesNames && (x.attendeesNames.some(a => a.name.toLowerCase().includes(residentSearchValueLower)))) ||
          (x.serviceRequestsResidentsNames && x.serviceRequestsResidentsNames.some(n => n.toLowerCase().includes(residentSearchValueLower)))
        );
      }

      return [...events];
    },
    eventsResidents() {
      let residents = [];
      const events =  this.getEventsByCalendarType(false)

      events.forEach((event) => {
        const attendeesNames = event.attendeesNames || []
        const residentsNames =  event.serviceRequestsResidentsNames || [];
        residents = residents.concat(attendeesNames, residentsNames);
      });
      residents = residents.filter((name, index) => residents.indexOf(name) === index && name?.length > 0);

      return residents;
    },
    eventsLocations() {
      const events = this.getEventsByCalendarType(false)
      let locations = events.map(x => x.location);
      locations = locations.filter((name, index) => locations.indexOf(name) === index && name?.length > 0);

      return locations;
    },
    
  },
  watch: {
    filters(newValue) {
      this.$store.dispatch("setMainCalendarFilters", {filters: newValue});
    },
    locationEnabled(newValue) {
      this.$store.dispatch("setMainCalendarFilters", {locationEnabled: newValue});
    },
    locationSearchValue(newValue) {
      this.$store.dispatch("setMainCalendarFilters", {locationSearchValue: newValue});
    },
    residentEnabled(newValue) {
      this.$store.dispatch("setMainCalendarFilters", {residentEnabled: newValue});
    },
    residentSearchValue(newValue) {
      this.$store.dispatch("setMainCalendarFilters", {residentSearchValue: newValue});
    },
    lifestyleProgramsEnabled(newValue) {
      this.$store.dispatch("setMainCalendarFilters", {lifestyleProgramsEnabled: newValue});
    },
    lifestyleProgramsSearchValue(newValue) { 
      this.$store.dispatch("setMainCalendarFilters", {lifestyleProgramsSearchValue: newValue});
    },
    type(newValue) {
      this.$store.dispatch("setMainCalendarFilters", {type: newValue});
    },
    categoryColor(newValue) {
      this.$store.dispatch("setMainCalendarFilters", {type: newValue});
    },
    selectedWingsIds(newValue) {
      this.$store.dispatch("setMainCalendarFilters", { wingsIds: newValue });
    }
  }
}